import script from "./PaperPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperPreview.vue?vue&type=script&setup=true&lang=js"

import "./PaperPreview.vue?vue&type=style&index=0&id=d6f99638&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6f99638"]])

export default __exports__